import { render, staticRenderFns } from "./TheAdmin.vue?vue&type=template&id=97f8c61c&scoped=true&"
import script from "./TheAdmin.vue?vue&type=script&lang=js&"
export * from "./TheAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f8c61c",
  null
  
)

export default component.exports